
import React from 'react'
import styled from 'styled-components'
import { Printer } from '@styled-icons/boxicons-regular/Printer'

export const ActionContainer = styled.div`
    display:flex;
    justify-content:end;
`
const WrapperIcon = styled.span`
  display: flex;
  justify-content: center;
  width: 100%;
`

const PrintStyled = styled(Printer)`
  cursor: pointer;
`

export const PrintButton = ({ handleClick }) => (
  <WrapperIcon>
    <PrintStyled onClick={handleClick} size={24} />
  </WrapperIcon>
)

export const BatchPrintContainer = styled.div`
  display:flex;
  justify-content:${(params) => (params.printEnable ? 'space-between' : 'end')};
  align-items:center;
  width:100%;
  
  span {
    text-align: start;
    ${(params) => (params.printEnable ? 'display:block' : 'display:none')};
  }
`